import { defineMessages } from 'gatsby-plugin-react-intl';
import { getTopicUrl } from './topics';

const messages = defineMessages({
  'prospectus.breadcrumbs.catalog': {
    id: 'prospectus.breadcrumbs.catalog',
    defaultMessage: 'Catalog',
    description: 'Root breadcrumb text for navigating to the entire catalog.',
  },
  'prospectus.breadcrumbs.courses': {
    id: 'prospectus.breadcrumbs.courses',
    defaultMessage: 'Courses',
    description: 'Breadcrumbs label for a given subject\'s courses.',
  },
});

const marketingSiteDomain = process.env.GATSBY_SITE_DOMAIN || '';
const getMarketingSiteLink = url => marketingSiteDomain + url;

const lmsDomain = process.env.GATSBY_LMS_DOMAIN || '';
const subscriptionDomain = process.env.GATSBY_SUBSCRIPTIONS_DOMAIN || '';

export const getLmsLink = url => lmsDomain + url;
export const getSubscriptionLink = url => subscriptionDomain + url;

const authnDomain = process.env.GATSBY_AUTHN_DOMAIN || '';
export const getAuthnMFELink = url => authnDomain + url;

const lms2CourseDomain = process.env.GATSBY_LMS_COURSE_DOMAIN || '';
export const getLmsToCourseLink = url => lms2CourseDomain + url;

const enterpriseDomain = process.env.GATSBY_ENTERPRISE_URL || '';
export const getEnterpriseLink = url => enterpriseDomain + url;

const getEnterpriseMarketingLinkData = ({
  locale,
  utmMedium,
  includeUrlWithQueryParams = false,
}) => {
  // Currently /es/ with param will cause 404 error for our enterprise site
  // We will keep the localization method but just remove /es, since we don't have spanish version yet.
  const pathsForLocale = {
    es: '',
  };
  const queryParams = {
    utm_campaign: process.env.GATSBY_ENTERPRISE_MARKETING_UTM_CAMPAIGN,
    utm_source: process.env.GATSBY_ENTERPRISE_MARKETING_UTM_SOURCE,
    utm_medium: utmMedium,
  };

  let enterpriseMarketingUrl = process.env.GATSBY_ENTERPRISE_MARKETING_URL;

  if (pathsForLocale[locale]) {
    enterpriseMarketingUrl = `${enterpriseMarketingUrl}${pathsForLocale[locale]}`;
  }

  const linkData = {
    url: enterpriseMarketingUrl,
    queryParams,
  };

  if (includeUrlWithQueryParams) {
    const urlSearchParams = new URLSearchParams(queryParams);
    linkData.urlWithQueryParams = `${enterpriseMarketingUrl}/?${urlSearchParams.toString()}`;
  }

  return linkData;
};

const getBaseBreadcrumbLinks = (intl, subject = {}, NotExecEd = false) => {
  const links = NotExecEd ? [{
    label: intl.formatMessage(messages['prospectus.breadcrumbs.catalog']),
    href: '/search',
  }] : [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'Executive Education',
      href: '/executive-education',
    },
  ];

  if (subject && subject.name && subject.name.length > 0) {
    let { subject: subjectForeignKey } = subject;
    subjectForeignKey = subjectForeignKey || {};
    const { labels = {} } = subjectForeignKey;
    const courseSubjectLabel = labels[intl.locale] ? labels[intl.locale] : subject.name;
    const courseSubjectUrl = getTopicUrl(intl.locale, subject.slug);

    links.push({
      label: `${courseSubjectLabel} ${intl.formatMessage(messages['prospectus.breadcrumbs.courses'])}`,
      href: courseSubjectUrl,
      subject: subject.name,
    });
  }

  return links;
};

// For getting the pathname from full links coming from APIs
const getPathFromUrl = (url) => {
  const domain = process.env.GATSBY_SITE_DOMAIN || 'edx.org';
  const indexOfDomain = url.indexOf(domain);

  if (indexOfDomain === -1) {
    return url;
  }

  const path = url.slice(url.indexOf(domain) + domain.length + 1);

  return path;
};

const isEdxLink = url => /(?:.*edx.org)/.test(url);

export {
  getMarketingSiteLink,
  getEnterpriseMarketingLinkData,
  getBaseBreadcrumbLinks,
  getPathFromUrl,
  isEdxLink,
};
